import { Component, OnInit, Input } from '@angular/core';
import { HistorialSuspension } from '../../../../api/interfaces/user';
import { StatusEnum } from '../../../../enums/status';
import { StudentService } from '../../../../services/admin/student/student.service';
import { SharedDataService } from '../../../../services/sharedData/shared-data.service';
import { SnackbarService } from '../../../../utils/snackbar/snackbar.service';

@Component({
  selector: 'app-status-history',
  templateUrl: './status-history.component.html',
  styleUrls: ['./status-history.component.scss']
})
export class StatusHistoryComponent implements OnInit {

  @Input('alumnoId') alumnoId: number;
  StatusEnum = StatusEnum;
  historial: HistorialSuspension[] = [];
  constructor(
    private studentService: StudentService,
    private snack: SnackbarService,
    private sharedData: SharedDataService
  ) { }

  ngOnInit(): void {
    this.sharedData.currentMessage.subscribe(message => {
    if(message =="updateStatus") {
      this.getHistorial();
    }
    });
    this.getHistorial();
  }

  getHistorial() {
    this.historial = [];
    this.studentService.getHistorialSuspensionesAlumno(this.alumnoId).subscribe(response => {
      this.historial = response;
    },
    error => {
      this.snack.snackTranslate('snacks.error.generic');
    })
  }

}
